import React, { lazy, Suspense } from 'react';
import { Helmet } from 'react-helmet';

import Layout from 'layouts/Layout';

import ErrorBoundary from 'components/Error/ErrorBoundary';
import ErrorMessage from 'components/Error/ErrorMessage';
import Loading from 'components/Loading/Loading';

import PromotionsState from 'context/Promotions/PromotionsState';
import CitiesState from 'context/Cities/CitiesState';
import AlliesState from 'context/Allies/AlliesState';

const Index = lazy(() => import('components/Promotions/Options/Index'));

export default function Promotions() {
    return (
        <>
        <Helmet>
            <title>Promociones - Conecta</title>
        </Helmet>
        <Layout>
            <ErrorBoundary fallback={<ErrorMessage OnClick={() => document.location.reload()} />}>
                <Suspense fallback={<Loading height="400px" spinner="spinner-border-primary" />}>
                    <PromotionsState>
                        <CitiesState>
                            <AlliesState>
                                <Index />
                            </AlliesState>
                        </CitiesState>
                    </PromotionsState>
                </Suspense>
            </ErrorBoundary>
        </Layout>
        </>
    )
}
